// import { useEffect, useState, useCallback, useMemo } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import DealCard from "../Vendor/VendorDeal/DealCard/DealCard";

// const DealsList = () => {
//   const [deals, setDeals] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showAllDeals, setShowAllDeals] = useState(false);
//   const navigate = useNavigate();
//   const currentLocation = localStorage.getItem("userLocation")
//     ? JSON.parse(localStorage.getItem("userLocation"))
//     : {};
//   const locationParams = {
//     longitude: currentLocation?.longitude,
//     latitude: currentLocation?.latitude,
//   };

//   const fetchDeals = useCallback(async () => {
//     setIsLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(
//         `https://api.upswap.app/api/deals/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       setDeals(response.data.deals || []);

//       setIsLoading(false);
//     } catch (err) {
//       console.error("Error fetching deals:", err);
//       setError("Failed to load deals. Please try again later.");
//       toast.error("Failed to load deals. Please check your connection.");
//       setIsLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchDeals();
//   }, [fetchDeals]);

//   const handleDealClick = (dealId) => {
//     navigate(`/DealDetails/${dealId}`); // Navigate to the DealDetails page
//   };

//   // Determine which deals to display based on showAllDeals state
//   const displayedDeals = useMemo(() => {
//     return showAllDeals ? deals : deals.slice(0, 5);
//   }, [deals, showAllDeals]);

//   // Toggle the showAllDeals state
//   const handleToggleView = () => {
//     setShowAllDeals((prevState) => !prevState);
//   };

//   // Only show the button if there are more than 6 deals
//   const shouldShowToggleButton = deals.length > 5; // Still checking this, even if not used in current render

//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center">
//         <div className="flex flex-col items-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className=" bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4">
//         <p className="text-red-500">Error: {error}</p>
//         <button
//           onClick={fetchDeals}
//           className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
//         >
//           Retry Loading Deals
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white ">
//       <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
//               Today's Best Deals
//             </h2>
//             <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
//               Discover amazing offers from local vendors
//             </p>
//           </div>
//         </div>

//         <div
//           className="
//     grid gap-4
//     grid-cols-2
//     sm:grid-cols-2
//     md:grid-cols-3
//     lg:grid-cols-4
//     xl:grid-cols-5
//     2xl:grid-cols-5
//   "
//         >
//           {displayedDeals.length > 0 ? (
//             <>
//               {displayedDeals.map((deal) => (
//                 <DealCard
//                   key={deal.deal_uuid}
//                   deal={deal}
//                   onClick={handleDealClick}
//                 />
//               ))}

//               {/* Post Deal Card placeholder is commented out */}
//             </>
//           ) : (
//             <div className="col-span-full text-center text-gray-600 p-8">
//               <p className="text-lg">
//                 No deals available at the moment. Check back soon!
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DealsList;

import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import DealCard from "../Vendor/VendorDeal/DealCard/DealCard";

const DealsList = () => {
  const [deals, setDeals] = useState([]);
  const [visibleDeals, setVisibleDeals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAllDeals, setShowAllDeals] = useState(false);

  const navigate = useNavigate();
  const currentLocation = localStorage.getItem("userLocation")
    ? JSON.parse(localStorage.getItem("userLocation"))
    : {};
  const locationParams = {
    longitude: currentLocation?.longitude,
    latitude: currentLocation?.latitude,
  };

  const fetchDeals = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://api.upswap.app/api/deals/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setDeals(response.data.deals || []);
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching deals:", err);
      setError("Failed to load deals. Please try again later.");
      toast.error("Failed to load deals. Please check your connection.");
      setIsLoading(false);
    }
  }, [locationParams?.latitude, locationParams?.longitude]);

  useEffect(() => {
    fetchDeals();
  }, [fetchDeals]);

  // Update visible deals based on screen size
  useEffect(() => {
    const updateVisibleDeals = () => {
      const isMobile = window.innerWidth < 768;
      const limit = showAllDeals ? deals.length : isMobile ? 6 : 5;
      setVisibleDeals(deals.slice(0, limit));
    };

    updateVisibleDeals();
    window.addEventListener("resize", updateVisibleDeals);
    return () => window.removeEventListener("resize", updateVisibleDeals);
  }, [deals, showAllDeals]);

  const handleDealClick = (dealId) => {
    navigate(`/DealDetails/${dealId}`);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4">
        <p className="text-red-500">Error: {error}</p>
        <button
          onClick={fetchDeals}
          className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
        >
          Retry Loading Deals
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
              Today's Best Deals
            </h2>
            <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
              Discover amazing offers from local vendors
            </p>
          </div>
        </div>

        <div
          className="
            grid gap-4
            grid-cols-2
            sm:grid-cols-2
            md:grid-cols-3
            lg:grid-cols-4
            xl:grid-cols-5
            2xl:grid-cols-5
          "
        >
          {visibleDeals.length > 0 ? (
            visibleDeals.map((deal) => (
              <DealCard
                key={deal.deal_uuid}
                deal={deal}
                onClick={handleDealClick}
              />
            ))
          ) : (
            <div className="col-span-full text-center text-gray-600 p-8">
              <p className="text-lg">
                No deals available at the moment. Check back soon!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DealsList;
